import { DropZone } from "@shopify/polaris";
import React from "react";

interface FileUploaderInterface {
    onDrop: (_dropFiles: any, acceptedFiles: any, _rejectedFiles: any) => void;
    accept?: string;
    type?: any;
    allowMultiple?: boolean;
    deactivated: boolean;
    maxFileSize?: number;
}

const MAX_FILE_SIZE = parseInt(
    process.env.REACT_APP_MAX_FILE_SIZE || "20000000"
);

export enum FileInvalidReason {
    SIZE = "SIZE",
    ZERO_BYTE = "ZERO_BYTE"
}

const FileUploader = (fileUploaderInterface: FileUploaderInterface) => {
    const uploadedFiles = null;
    const fileUpload = (
        <DropZone.FileUpload
            actionTitle="Add file"
            actionHint="Or drop files to upload"
        />
    );
    const defaultAccept = "image/jpeg, image/png";
    const defaultType = "image";
    const maxFileSize =
        fileUploaderInterface.maxFileSize === undefined
            ? MAX_FILE_SIZE
            : fileUploaderInterface.maxFileSize;

    interface UploadFile extends File {
        readonly lastModified: number;
        readonly name: string;
        rejectReason: FileInvalidReason;
    }


    const fileSizeValid = (file: UploadFile) => {

        if (file.size === undefined || file.size == 0) {
            file.rejectReason = FileInvalidReason.ZERO_BYTE;
            return false;
        }

        if (file.size >= maxFileSize) {
            file.rejectReason = FileInvalidReason.SIZE;
            return false;
        }
        return true;
    };

    const allowMultiple =
        fileUploaderInterface.allowMultiple === undefined
            ? true
            : fileUploaderInterface.allowMultiple;
    return (
        <div className={"dropzone"}>
            <DropZone
                disabled={fileUploaderInterface.deactivated}
                accept={fileUploaderInterface.accept || defaultAccept}
                type={fileUploaderInterface.type || defaultType}
                allowMultiple={allowMultiple}
                customValidator={fileSizeValid}
                onDrop={fileUploaderInterface.onDrop}
            >
                {uploadedFiles}
                {fileUpload}
            </DropZone>
        </div>
    );
};

export default FileUploader;
